export default __webpack_public_path__ + "static/leadership_chart-cf4c53d5aced51a6bacd24748c364943.svg";